import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { fetchAddCryptoWallet } from "../../pages/FetchAddWallet";
import { addedCryptoWallet } from "../../store/actions/cryptoWalletsAction";
import USDT from "../../assets/images/USDT-logo.png";
import Input from "../common/Input";
import { useState } from "react";

function AddCryptoWalletForm({ closePopup }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const [num, setNum] = useState("");

  const handleNameChange = (e) => {
    // handle name change
    setName(e.target.value);
  };

  const handleNumChange = (e) => {
    // handle number change
    setNum(e.target.value);
  };

  // handle form submit
  const handleSubmit = (e) => {
    e.preventDefault();
    fetchAddCryptoWallet({ name, num }).then((data) => {
      addedCryptoWallet(dispatch, data);
      closePopup();
    });
  };

  return (
    <form onSubmit={handleSubmit} className="wallet__add">
      <button onClick={() => closePopup()} className="close-popup">
        <i className="ri-close-line"></i>
      </button>
      <h3>{t("Add Crypto Wallet")}</h3>
      <div className="wallet__add-crypto-curr">
        <p className="label">{t("Currency")}</p>
        <div className="wallet__add-crypto-USDT">
          <img src={USDT} alt="" />
          <p>USDT (TRC-20)</p>
        </div>
      </div>
      <div className="wallet_add-wrapper">
        <Input
          id="name"
          label={t("Name")}
          value={name}
          onChange={handleNameChange}
          placeholder={t("Enter name")}
          pattern=".*"
          required
        />
        <Input
          id="num"
          label={t("Wallet address")}
          value={num}
          onChange={handleNumChange}
          placeholder={t("Enter wallet address")}
          pattern=".*"
          required
        />
      </div>
      <button
        className="form-default__submit"
        type="submit"
      >
        {t("Save")}
      </button>
      <button onClick={() => closePopup()} className="form-default__cancel only-mobile">
        {t("Cancel")}
      </button>
    </form>
  );
}

export default AddCryptoWalletForm;
